import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';

import scss from './NoAttemptsModal.module.scss';

function BenefitList() {
  const { t } = useTranslation('demoAdImages');

  const BENEFIT_LIST = [t('benefit1'), t('benefit2'), t('benefit3'), t('benefit4')];

  return (
    <div className={scss.benefitWrapper}>
      <ul className={scss.benefitList}>
        {BENEFIT_LIST.map((benefit) => (
          <li key={benefit} className={scss.benefitItem}>
            <CheckCircleOutlineRoundedIcon color='#fdbf47' />
            {benefit}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BenefitList;
